/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParametroProgramaModelDto } from '../../models/parametro-programa-model-dto';

export interface ProgramaParametrosControllerGetProgramParametrizaciones$Params {
  programaUuid: string;
}

export function programaParametrosControllerGetProgramParametrizaciones(http: HttpClient, rootUrl: string, params: ProgramaParametrosControllerGetProgramParametrizaciones$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParametroProgramaModelDto>>> {
  const rb = new RequestBuilder(rootUrl, programaParametrosControllerGetProgramParametrizaciones.PATH, 'get');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ParametroProgramaModelDto>>;
    })
  );
}

programaParametrosControllerGetProgramParametrizaciones.PATH = '/api/programa-parametros/{programaUuid}';
